module.exports = __webpack_public_path__ + "static/media/line3.46731903.png";